{
    "name": "Corn",
    "binomial_name": "Zea mays",
    "common_names": [
        "Maize",
        "Corn"
    ],
    "description": "Corn is a large grain plant, or tall grass, first domesticated about 10,000 years ago by indigenous peoples in Southern Mexico. The leafy stalk produces ears after pollination. Depending on the variety, the corn can be eaten fresh, or dried and ground into cornmeal.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed outdoors",
    "spread": 50,
    "row_spacing": 76,
    "height": 290,
    "growing_degree_days": 100,
    "companions": [],
    "image": "/crops/images/corn.jpg",
    "icon": "/crops/icons/corn.avif"
}